import React from 'react';

import Responsive from '@/components/Responsive';

import FilterItemDesktop from './index.desktop';
import FilterItemMobile from './index.mobile';
import { FilterItemProps } from './types';

const FilterItem = (props: FilterItemProps) => {
  return (
    <Responsive>
      <Responsive.Default>
        <FilterItemDesktop {...props} />
      </Responsive.Default>
      <Responsive.Mobile>
        <FilterItemMobile {...props} />
      </Responsive.Mobile>
    </Responsive>
  );
};

export default FilterItem;
